import { render, staticRenderFns } from "./ChangeKennelOwnerSignature.vue?vue&type=template&id=76be2e3a"
import script from "./ChangeKennelOwnerSignature.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnerSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports